class PageRating {
  constructor() {
    this.rating = null;
    this.start = this.start.bind(this);
    this.popupStarClick = this.popupStarClick.bind(this);
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.showInfo = this.showInfo.bind(this);
    this.submit = this.submit.bind(this);
  }

  start() {
    fetch(`/api/v1/reviews/?url=${window.location.origin + window.location.pathname}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.results.length) {
          this.showInfo(data.results[0]);
        }
      });

    const stars = document.querySelectorAll('.rating-block__star');

    if (stars.length) {
      stars.forEach((button) => button.addEventListener('click', () => this.starClick(button)));

      const popupStars = document.querySelectorAll('.rating-block__popup-star');
      popupStars.forEach((starButton) => starButton.addEventListener('click', () => this.popupStarClick(starButton)));

      const openButton = document.querySelector('.rating-block__open-popup');
      openButton.addEventListener('click', this.openPopup);

      const submitButton = document.querySelector('.rating-block__popup-content-submit');
      submitButton.addEventListener('click', this.submit);

      const closeButton = document.querySelector('.rating-block__popup-close');
      closeButton.addEventListener('click', this.closePopup);

      const noindexMeta = document.querySelector('meta[content=noindex]');

      if (noindexMeta) {
        document.querySelector('.rating-block').style.display = 'none';
      }
    }
  }

  starClick(button) {
    const buttonRating = parseInt(button.className.match(/\d+/), 10);
    if (document.querySelector('.rating-block__popup-star-active')) {
      document.querySelector('.rating-block__popup-star-active').classList.remove('rating-block__popup-star-active');
    }
    document.querySelector(`.rating-block__popup-star-${buttonRating}`).classList.add('rating-block__popup-star-active');

    this.rating = buttonRating;
    this.openPopup();
  }

  popupStarClick(button) {
    const buttonRating = parseInt(button.className.match(/\d+/), 10);
    if (document.querySelector('.rating-block__popup-star-active')) {
      document.querySelector('.rating-block__popup-star-active').classList.remove('rating-block__popup-star-active');

      if (this.rating === buttonRating) return;
    }
    button.classList.add('rating-block__popup-star-active');
    this.rating = buttonRating;
  }

  openPopup() {
    document.querySelector('.rating-block__popup').style.display = 'flex';
    document.querySelector('.rating-block__popup-content').style.display = 'flex';
    document.querySelector('.rating-block__popup-success').style.display = 'none';
  }

  closePopup() {
    document.querySelector('.rating-block__popup').style.display = 'none';
  }

  showInfo(data) {
    const infoBlock = document.querySelector('.rating-block__info');

    infoBlock.innerHTML = `<span itemprop="ratingValue">${data.reviews_rating}</span> из 5 (<span itemprop="ratingCount">${data.reviews_count}</span>)`;
    this.rating = data.reviews_rating;

    if (document.querySelector('.rating-block__star-active')) {
      document.querySelector('.rating-block__star-active').classList.remove('rating-block__star-active');
    }

    document.querySelector(`.rating-block__star-${this.rating}`).classList.add('rating-block__star-active');
  }

  submit() {
    if (!this.rating) return;
    fetch('/api/v1/reviews/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        url: window.location.origin + window.location.pathname,
        rating: this.rating,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        document.querySelector('.rating-block__popup-content').style.display = 'none';
        document.querySelector('.rating-block__popup-success').style.display = 'block';
        this.showInfo(data);
      });
  }
}

module.exports = PageRating;
